import { setUpModernPage } from 'js/simple_layout/set_up_modern_page';
import { trackClick } from 'js/utils/trackClick';
import { FigureMoreActionsMenu } from 'js/attachment_extracted_images/FigureMoreActionsMenu';
import { LoginModalManager } from 'js/login_modal/LoginModalManager';
import registerForRails from 'js/utils/registerForRails';

registerForRails({ FigureMoreActionsMenu, LoginModalManager });

const attachmentExtractedImageId = window.location.pathname.split('/')[2];

setUpModernPage({
  loginButtonOptions: {
    pageName: 'attachment_extracted_image',
    registrationParams: { user_source: 'attachment_extracted_image' },
    clickTrackingContext: { entityId: attachmentExtractedImageId },
  },
});

window.addEventListener('DOMContentLoaded', () => {
  const seeWorkButton = document.querySelector('.js-aei-see-work-button');
  const downloadButton = document.querySelector('.js-aei-download-button');

  const figuresCarouselPrevButton = document.querySelector(
    '.js-aei-figures-prev',
  );
  const figuresCarouselNextButton = document.querySelector(
    '.js-aei-figures-next',
  );

  seeWorkButton?.addEventListener('click', () => {
    trackClick({
      source: 'see-work-button--aei-work-card',
      entityId: attachmentExtractedImageId,
    });
  });

  downloadButton?.addEventListener('click', () => {
    trackClick({
      source: 'download-button--aei-work-card',
      entityId: attachmentExtractedImageId,
    });
  });

  // Track clicks on figure work title
  const figureWorkTitle = document.querySelector('.figure-work-title');
  figureWorkTitle?.addEventListener('click', () => {
    trackClick({
      source: 'aei-figure-card-work-title',
      entityId: attachmentExtractedImageId,
    });
  });

  // Track clicks on main image navigation buttons
  const mainImageNavButtonRight = document.querySelector(
    '.main-image-nav-button--right',
  );
  const mainImageNavButtonLeft = document.querySelector(
    '.main-image-nav-button--left',
  );

  mainImageNavButtonRight?.addEventListener('click', () => {
    trackClick({
      source: 'aei-main-image-nav-button--right',
      entityId: attachmentExtractedImageId,
    });
  });

  mainImageNavButtonLeft?.addEventListener('click', () => {
    trackClick({
      source: 'aei-main-image-nav-button--left',
      entityId: attachmentExtractedImageId,
    });
  });

  // Track clicks on engagement banner button
  const engagementBannerBtn = document.querySelector('.engagement-banner-btn');
  engagementBannerBtn?.addEventListener('click', () => {
    trackClick({
      source: 'aei-engagement-banner-button',
      entityId: attachmentExtractedImageId,
    });
  });

  // Track clicks on work card elements (for each work card)
  const workCards = document.querySelectorAll(
    '.aei-work-card',
  ) as NodeListOf<HTMLElement>;

  workCards.forEach((workCard) => {
    const workId = workCard.getAttribute('data-work-id');

    // Track title link clicks
    const titleLink = workCard.querySelector(
      '.aei-work-card-title-link',
    ) as HTMLElement;
    titleLink?.addEventListener('click', () => {
      trackClick({
        source: 'aei-work-card-title-link',
        entityId: workId || attachmentExtractedImageId,
      });
    });

    // Track thumbnail link clicks
    const thumbnailLinks = workCard.querySelectorAll(
      '.thumbnail-link',
    ) as NodeListOf<HTMLElement>;
    thumbnailLinks.forEach((thumbnailLink) => {
      thumbnailLink.addEventListener('click', () => {
        trackClick({
          source: 'aei-work-card-thumbnail-link',
          entityId: workId || attachmentExtractedImageId,
        });
      });
    });

    // Track author link clicks
    const authorsContainer = workCard.querySelector(
      '.aei-work-card-authors',
    ) as HTMLElement;
    if (authorsContainer) {
      const authorLinks = authorsContainer.querySelectorAll('a');
      authorLinks.forEach((authorLink) => {
        authorLink.addEventListener('click', () => {
          trackClick({
            source: 'aei-work-card-author-link',
            entityId: workId || attachmentExtractedImageId,
          });
        });
      });
    }

    // Track view paper button container clicks
    const viewPaperButtonContainer = workCard.querySelector(
      '.aei-work-card-view-paper-button-container',
    ) as HTMLElement;
    const viewPaperButtonLink = viewPaperButtonContainer?.querySelector('a');
    viewPaperButtonLink?.addEventListener('click', () => {
      trackClick({
        source: 'aei-work-card-view-paper-button',
        entityId: workId || attachmentExtractedImageId,
      });
    });
  });

  const figuresCarouselClickHandler = (source: string) => {
    trackClick({
      source,
      entityId: attachmentExtractedImageId,
    });
  };

  figuresCarouselPrevButton?.addEventListener('click', () =>
    figuresCarouselClickHandler('aei--figures-carousel-prev'),
  );

  figuresCarouselNextButton?.addEventListener('click', () =>
    figuresCarouselClickHandler('aei--figures-carousel-next'),
  );

  // Set up abstract read more toggles for all work cards
  const readMoreButtons = document.querySelectorAll(
    '.js-aei-work-card-read-more-button',
  ) as NodeListOf<HTMLElement>;
  const abstractWrappers = document.querySelectorAll(
    '.js-aei-work-card-abstract-wrapper',
  ) as NodeListOf<HTMLElement>;

  // Function to check if abstract text is actually truncated
  const checkIfTruncated = (wrapper: HTMLElement): boolean => {
    const abstractText = wrapper.querySelector(
      '.js-aei-work-card-abstract-text',
    ) as HTMLElement;
    if (!abstractText) {
      return false;
    }

    // Compare scrollHeight with clientHeight to detect truncation
    // If scrollHeight > clientHeight, the content is truncated
    return abstractText.scrollHeight > abstractText.clientHeight;
  };

  // Function to update truncation state for all abstracts
  const updateTruncationState = () => {
    abstractWrappers.forEach((wrapper, index) => {
      const isTruncated = checkIfTruncated(wrapper);
      const button = readMoreButtons[index] as HTMLElement;

      if (isTruncated) {
        wrapper.setAttribute('data-truncated', 'true');
        if (button) {
          button.style.display = '';
        }
      } else {
        wrapper.setAttribute('data-truncated', 'false');
        if (button) {
          button.style.display = 'none';
        }
      }
    });
  };

  // Check truncation state on initial load
  updateTruncationState();

  // Re-check on window resize (debounced for performance)
  let resizeTimeout: ReturnType<typeof setTimeout>;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateTruncationState();
    }, 150);
  });

  readMoreButtons.forEach((button, index) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      const wrapper = abstractWrappers[index] as HTMLElement;
      if (wrapper) {
        wrapper.setAttribute('data-truncated', 'false');
      }
      // Remove the button completely so text reflows naturally
      button.remove();

      trackClick({
        source: 'aei-work-card-read-more-abstract',
        entityId: attachmentExtractedImageId,
      });
    });
  });
});
